const en_US = {
  'android': `Android`,
  'contact_us': `Contact us`,
  'cookie_accept_all': `Accept All`,
  'cookie_accept_selected': `Confirm my choices`,
  'cookie_learn_more': `Learn more`,
  'cookie_settings': `Cookie Settings`,
  'cookie_settings_desc': `This website uses cookies for website functionality, traffic analytics, personalization, social media functionality and advertising. Our Cookie Notice provides more information and explains how to amend your cookie settings.`,
  'cookie_toggle_required': `Strictly Necessary Cookies`,
  'cookie_toggle_required_desc': `These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.`,
  'cookie_toggle_performance': `Performance Cookies`,
  'cookie_toggle_performance_desc': `These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.`,
  'copyright_statement': `Copyright © 2023 Trend Micro Incorporated. All rights reserved.`,
  'device_detail': `Device Details`,
  'expired_on': `Expired on `,
  'expires_on': `Expires on `,
  'help_center': `Help Center`,
  'ios': `iOS`,
  'label_alarm': `Alarm`,
  'label_locate': `Locate`,
  'label_lock': `Lock`,
  'label_lost_device_protection': `Lost Device Protection`,
  'label_reset': `Reset`,
  'label_trend_micro': `Trend Micro`,
  'label_wipe': `Wipe`,
  'landing_page_android_only': `Android Only`,
  'landing_page_description': `Makes it easy to locate, lock or wipe a missing mobile device.`,
  'landing_page_description_main_function': `Protect your device from loss, data theft, and more.`,
  'landing_page_download_from': `Download Trend Micro Apps from:`,
  'landing_page_finditnow': `Find Now`,
  'landing_page_locate': `Locate`,
  'landing_page_locate_description': `Find your mobile device anywhere at any time.`,
  'landing_page_lock': `Lock`,
  'landing_page_lock_description': `Stop anyone from using your lost mobile device.`,
  'landing_page_alarm': `Alarm`,
  'landing_page_alarm_description': `Sound a one-minute alert by remote control.`,
  'landing_page_title': `Trend Micro Lost Device Protection Portal`,
  'landing_page_wipe': `Wipe`,
  'landing_page_wipe_description': `Delete all of the data stored on your lost device.`,
  'license_day': `DAY`,
  'license_days': `DAYS`,
  'license_expired': `Subscription Expired`,
  'license_vaild_subscription': `Valid Subscription`,
  'location_not_found': `No Location Detected`,
  'map_no_device': `No device protected! To locate a device, install protection now.`,
  'policies_privacy': `Legal Policies & Privacy`,
  'sign_in': `Sign In`,
  'sign_out': `Sign Out`,
  'trendmicrocom': `Trend Micro`,
  'unlock_key': `Unlock Key: `,
  'unlock_key_wording': `Use this key to unlock your mobile device.`,
  // tmpn success message
  'message_alarm_success': `An alarm is sounding on {0}`,
  'message_locate_success': `Refreshing the location of {0}`,
  'message_lock_success': `{0} is locked`,
  'message_wipe_success': `All the data on {0} has been removed.`,
  // tmpn POST command error
  "error_alarm": `Unable to sound an alarm on {0}`,
  "error_locate": `Unable to locate {0}`, 
  "error_lock": `Unable to lock {0}`, 
  "error_wipe": `Unable to wipe {0}`, 
  // tmpn GET command error
  'error_alarm_CS001': `Cannot access your device through the Internet.`,
  'error_alarm_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS001': `Cannot access your device through the Internet.`,
  'error_locate_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_locate_CS004': `Unable to display the location because GPS on mobile device is disabled.`,
  'error_lock_CS001': `Cannot access your device through the Internet.`,
  'error_lock_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_wipe_CS001': `Cannot access your device through the Internet.`,
  'error_wipe_CS003': `You did not enable Lost Device Protection and grant device administrator permission yet.`,
  'error_default': `Unable to perform your request at the moment.`,
  // product name
  'product_name_IS10': `Trend Micro™ Mobile Security for iOS`,
  'product_name_IS11': `Trend Micro™ Mobile Security for iOS`,
  'product_name_IS12': `Trend Micro™ Mobile Security for iOS`,
  'product_name_IS13': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_IS14': `iOS 版的安全達人`,
  'product_name_IS27': `Trend Micro™ Mobile Security for iOS`,
  'product_name_ISM0': `Trend Micro Mobile Security Okaeri`,
  'product_name_ISM1': `Trend Micro Mobile Security Okaeri`,
  'product_name_MS20': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS21': `ウイルスバスター モバイル for Android™`,
  'product_name_MS23': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS24': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS25': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS26': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS27': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS29': `Trend Micro™ Go Everywhere`,
  'product_name_MS31': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS30': `Trend Micro™ Mobile Security - Personal Edition`,
  'product_name_MS33': `趨勢科技™ 行動安全防護 - 全民版`,
  'product_name_MS34': `Android™ 版的安全達人`,
  'product_name_MS36': `Virus Buster™ Mobile meets Hello Kitty`,
  'product_name_MSM0': `Trend Micro Mobile Security Okaeri`,
  'product_name_MSM1': `Trend Micro Mobile Security Okaeri`,
};

export default en_US;
